//Entry point for ES2015 and earlier Javascript
import "jquery";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "fancybox/dist/jquery.fancybox.min.css";

const lunr = require("lunr");

var updateLoginButton = function (data) {
  var data = data || {};

  if (data.logged_in) {
    $('#login_link_href').attr('href', '/logout');
    $('#login_link_text').text('Logout');
    $('#login_button').attr('title', 'You are logged in as ' + data.user_identifier);
  } else {
    $('#login_link_href').attr('href', '/login');
    $('#login_link_text').text('Login / Register');
    $('#login_button').attr('title', '');
  }
};

var updateProfileLink = function (logged_in) {
  if (logged_in) {
    $('#profile_link').html("<a href='/profile'>Profile</a>")
  } else {
    $('#profile_link').html('')
  }
};

$(document).ready(function () {
  // Download index data
  $.ajax({
    url: '/search/lunr-index.json',
    cache: true,
    method: 'GET',
    success: function (data) {
      var searchResultsHtml = "";
      var searchValue = decodeURI(window.location.hash.substr(1));
      var searchResults = lunr.Index.load(data.index).search(searchValue);

      $('.search-box').val(searchValue);

      if (searchValue.length === 0) {
        searchResultsHtml = '<p>Enter search terms in the search field</p>';
      } else
      if (searchResults.length === 0) {
        searchResultsHtml = '<p class="no-search-results">No Results Found</p>';
      } else {
        searchResultsHtml = createSearchResponse(searchResults, data);
      }

      $('.main-content .search-results').html(searchResultsHtml);
    },
    error: function () {
      console.log("Didn't load search data");
    }
  });

  $.ajax({
    type: 'GET',
    url: '/login_check',
    dataType: 'json',
    xhrFields: {
      withCredentials: true
    },
    success: function (data) {
      var href;
      var text;

      updateLoginButton(data);
      updateProfileLink(data.logged_in)
    },
    error: function () {
      updateLoginButton({
        logged_in: false
      });
      updateProfileLink(false)
    }
  });

  // Search Function
  $(".search-button").on('click',
    function (e) {
      window.location = '/search-results.html#' + $(e.target).parents('.input-group').find('.search-box').val();
    });

  $(".search-box").keypress(function (e) {
    if (e.which == 13)
      $(e.target).parents('.input-group').find(".search-button").click();
  });
});

// handle back button. Origin pages have empty states. If we get to an orgin page
// reload the page to present the user with what they expect.
$(window).on("popstate", function (e) {
  if (e.state == null) {
    location.reload();
  }
});

var createSearchResponse = function createSearchResponse(searchResults, lunrData) {
  var response = "";
  searchResults.forEach(function (item) {
    var result = lunrData.docs[item.ref];
    var description = result.content.substring(0, 120);
    response = response + '<li class="result-item">' + '<a href="' + result.url + '">' + result.title + '</a>' + '<p>' + description + '</p></li>';
  });
  return '<h1>Search Results</h1><ul class="search-results">' + response + '</ul>';
};


jQuery(document).on('click', '.mega-dropdown', function (e) {
  e.stopPropagation();
});

$('ul.nav li.dropdown').hover(function () {
  $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(500);
}, function () {
  $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(500);
});


$('.morebtn').click(function () {
  var $this = $(this);
  $this.toggleClass('morebtn');
  if ($this.hasClass('morebtn')) {
    $this.text('More');
  } else {
    $this.text('Less');
  }
});


// WEBPACK FOOTER //
// source/javascripts/index.js